"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PageBackgroundColor = require("./PageBackgroundColor");
Object.keys(_PageBackgroundColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PageBackgroundColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PageBackgroundColor[key];
    }
  });
});
